import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import {Link} from "react-router-dom";
import ArticleDelete from "../../ArticleDelete/ArticleDelete";
import ArticleView from "../../ArticleView/ArticleView";

class ArticlesRow extends Component{

    constructor(props) {
        super(props);
        this.state = {
            authorName: '',
            articleData:[]
        };
        this.getAuthorName = this.getAuthorName.bind(this);
    }

    getAuthorName = () => {

        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.articles.author )
            .then((res) => {
                this.setState({
                    authorName: res.data.name

                });
                // console.log(res.data);
            })
            .catch((err) => {

                console.log("[API] ERROR: ", err);
            });
    };

    componentDidMount() {
        this.getAuthorName();
    }

    render() {
        return (
            <tr>
                <td> {this.props.no}</td>
                <td>
                    {this.props.articles.createdDate.substring(0,4)} 年 {this.props.articles.createdDate.substring(5,7)} 月 {this.props.articles.createdDate.substring(8,10)} 日

                </td>
                <td>
                    {this.props.articles.title}
                </td>
                <td>
                    {this.state.authorName}
                </td>

                <td>
                    <ArticleView articleData={this.props.articles} author={this.state.authorName}/>&nbsp;
                    {/*<a className="btn btn-xs btn-warning article-btn">
                                <Link to={{
                                    pathname: "/admin/article/edit",
                                    state: {
                                        articleData: this.props.articles
                                    }
                                }}
                                >
                                    <FormattedMessage id="app.article-row.edit"
                                                      defaultMessage="Edit"
                                                      description=""/>
                                </Link>
                            </a>*/}
                    <a className="btn btn-xs btn-warning article-btn article-btn2 article-edit-btn-resp">
                        <Link to={"/admin/article/edit/" + this.props.articles.id}>
                            <FormattedMessage id="app.article-row.edit"
                                              defaultMessage="Edit"
                                              description=""/>
                        </Link>
                    </a>
                    &nbsp;
                    <span className="delete-article-admin-resp">
                        <ArticleDelete articleId={this.props.articles.id}
                                       getAll={this.props.getAll}/>
                    </span>
                </td>
            </tr>
        )
    }

}
export default ArticlesRow;



// WEBPACK FOOTER //
// ./src/components/Admin/Articles/ViewAllArticles/ArticlesRow/ArticlesRow.js